import React from 'react'

{/*import { useState } from 'react'
import  Header  from '../components/Header.jsx'
import  TopNavbar  from '../components/TopNavbar.jsx'

import  Hero  from '../components/Hero.jsx'
import  LoginPopup  from '../components/LoginPopup.jsx'
import Hero1 from '../components/hero1.jsx'*/}


const Home = () => {
  
  
 {/*const [loginPopup, setLoginPopup] = useState(true);
  const toggleLoginPopup = () => { setLoginPopup((prev) => !prev); } */}
  return (  
    
    <>
    
 {/*<div className={loginPopup ? "" : ""}>
<Header toggleLoginPopup={toggleLoginPopup} /> 
<Hero toggleLoginPopup={toggleLoginPopup}  />*
<LoginPopup toggleLoginPopup={toggleLoginPopup} loginPopup={loginPopup} />
</div>

     <Header />
    <TopNavbar />
    <Hero1 />*/}




    
    
   
    

  

    </>
          



    
  )
}

export default Home;